var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.50008 10C9.43307 10 11.0001 8.433 11.0001 6.5C11.0001 4.567 9.43307 3 7.50008 3C5.56708 3 4.00008 4.567 4.00008 6.5C4.00008 8.433 5.56708 10 7.50008 10ZM7.50008 9C8.88079 9 10.0001 7.88071 10.0001 6.5C10.0001 5.11929 8.88079 4 7.50008 4C6.11936 4 5.00008 5.11929 5.00008 6.5C5.00008 7.88071 6.11936 9 7.50008 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5001 21C18.4331 21 20.0001 19.433 20.0001 17.5C20.0001 15.567 18.4331 14 16.5001 14C14.5671 14 13.0001 15.567 13.0001 17.5C13.0001 19.433 14.5671 21 16.5001 21ZM16.5001 20C17.8808 20 19.0001 18.8807 19.0001 17.5C19.0001 16.1193 17.8808 15 16.5001 15C15.1194 15 14.0001 16.1193 14.0001 17.5C14.0001 18.8807 15.1194 20 16.5001 20Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8536 4.85355C20.0488 4.65829 20.0488 4.34171 19.8536 4.14645C19.6583 3.95118 19.3417 3.95118 19.1464 4.14645L4.14645 19.1464C3.95118 19.3417 3.95118 19.6583 4.14645 19.8536C4.34171 20.0488 4.65829 20.0488 4.85355 19.8536L19.8536 4.85355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversion);
export default __webpack_public_path__ + "static/media/Conversion.a1f57cd4690ad3a4c031dd48089c082e.svg";
export { ForwardRef as ReactComponent };